import React, { useEffect, useState } from 'react';
import { isAddress } from 'ethers/lib/utils';
import { useSnackbar } from 'notistack';
import { useConnectModal, useChainModal } from '@rainbow-me/rainbowkit';
import { useAccount, useChainId } from 'wagmi';
import {
    Dialog,
    TextField,
    InputAdornment,
    IconButton,
    DialogTitle,
    DialogContent,
    List,
    ListItem,
    ListItemAvatar,
    Avatar,
    ListItemText,
    Typography,
    Tooltip,
    Backdrop,
    CircularProgress,
    Alert,
    Button,
    Box
} from '@mui/material';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import 'react-tabs/style/react-tabs.css';

import ethIcon from '../../assets/images/coin/eth.png';
import bnbIcon from '../../assets/images/coin/bnb.png';
import solIcon from '../../assets/images/coin/sol.png';
import baseIcon from '../../assets/images/coin/base-logo.png';
import avaxIcon from '../../assets/images/coin/avax.png';

import avalancheTokens from '../../constants/avalanche_tokens';
import baseTokens from '../../constants/base_tokens';
import mainnetTokens from '../../constants/mainnet_tokens';
import bscTokens from '../../constants/bsc_tokens';

import { getTokenInfo, getUserBalance, submitDumpster, getDumpsterSubmissionAllowance, customApprove } from '../../helpers';

const defaultTokens = [
    ...mainnetTokens,
    ...baseTokens,
    ...bscTokens,
    ...avalancheTokens
];
 
const chainIcons = {
    "Ethereum": ethIcon,
    "Base": baseIcon,
    "Binance Smart Chain": bnbIcon,
    "Avalanche": avaxIcon
};

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .MuiTooltip-tooltip`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9'
    }
}));

const AirdropForm = ({ hideBanner }) => {


    const chainId = useChainId();
    const { openChainModal } = useChainModal();
    const { openConnectModal } = useConnectModal();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [userTokenBalance, setUserTokenBalance] = useState('0.00');
    const [tokenAmount, setTokenAmount] = useState('')
    const [openTokenDialog, setOpenTokenDialog] = useState(false);
    const [customTokenAddress, setCustomTokenAddress] = useState('');
    const [tokenAddressError, setTokenAddressError] = useState('');
    const [selectedTokenSymbol, setSelectedTokenSymbol] = useState('Select Token');
    const [selectedToken, setSelectedToken] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [isDark, setIsDark] = useState(document.body.classList.contains('is_dark'));
    const [isFetching, setIsFetching] = useState(false);
    const [buttonName, setButtonName] = useState('Connect Wallet');
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');

    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);

    const { address } = useAccount();
    const theme = useTheme();
 

    
    useEffect(() => {
        setIsFetching(true);
        if (address) {
            // handleGetUserData(); 
        }

    }, [address]);

    useEffect(() => {
        const observer = new MutationObserver(() => {
            setIsDark(document.body.classList.contains('is_dark'));
        });
        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        validateUserData()

    }, [address, tokenAmount, selectedToken, chainId])


    useEffect(() => {
        const fetchTokenInfo = async () => {
            if (customTokenAddress && isAddress(customTokenAddress)) {
                setLoading(true);
                try {
                    const results = await getTokenInfo(customTokenAddress);
                    setSearchResults(results);
                } catch (err) {
                    console.error(err);
                    setSearchResults([]);
                } finally {
                    setLoading(false);
                }
            } else {
                setSearchResults([]);
            }
        };

        fetchTokenInfo();
    }, [customTokenAddress]);



    useEffect(() => {
        setTokenAmount('')
        setUserTokenBalance('')
        handleGetBalance()
    }, [selectedToken, address, chainId])


    const handleGetBalance = async () => {
        try {
            setIsFetching(true)
            if (isAddress(selectedToken?.address || '') && !!selectedToken && address) {
                if (getChainId(selectedToken.network) != chainId.toString()) return;
                const balance = await getUserBalance(selectedToken.address, address)
                if (balance.success) {
                    setUserTokenBalance(balance.originalBalance)
                }
            }
        } catch (e) {
            console.log(e.message)
        } finally {
            setIsFetching(false)
        }
    }

    const getChainId = (chainName) => {
        if (chainName == 'Avalanche') {
            return '43114'
        } else if (chainName == 'Binance Smart Chain') {
            return '56'
        } else if (chainName == 'Binance Smart Chain') {
            return '97'
        } else if (chainName == 'Base') {
            return '8453'
        } else if (chainName == 'Ethereum') {
            return '1'
        } else {
            return ''
        }
    }
 
    const handleTokenAddressChange = (e) => {
        const addr = e.target.value;
        setCustomTokenAddress(addr);

        if (addr && !isAddress(addr)) {
            setTokenAddressError('Invalid ERC20 token address format');
            setSearchResults([]);
        } else {
            setTokenAddressError('');
        }
    };
 
    function beautifyNumber(number, maxFraction) {
        if (typeof number !== 'number' && isNaN(Number(number))) {
            throw new Error('Input must be a valid number');
        }
        return Number(number).toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: maxFraction
        });
    }


    const handelProcess = async () => {
        if (!address) {
            openConnectModal();
            return;
        }

        if (!selectedToken) {
            setCustomTokenAddress('');
            setSearchResults([]);
            setOpenTokenDialog(true);

            return;
        }

        if (chainId) {
            if (getChainId(selectedToken.network) != chainId.toString()) {
                openChainModal()
                return;
            }
        } else {
            openChainModal()
            return;
        }



        if (!!selectedToken && !!address && parseFloat(tokenAmount) > 0 && parseFloat(userTokenBalance) >= parseFloat(tokenAmount)) {
 
            setIsFetching(true)
            const allowanceResponse = await getDumpsterSubmissionAllowance(selectedToken.address, address, selectedToken.decimals)
            if (allowanceResponse.success) {

                if (parseFloat(allowanceResponse.allowance) < parseFloat(tokenAmount)) {
                    setButtonName(`Approve ${selectedToken.symbol.toUpperCase()}`);

                    // Approve
                    const approvalResponse = await customApprove(selectedToken.address, tokenAmount)
                    if (approvalResponse.success) {
                        snackMessage(approvalResponse.message, 'success')
                        setButtonName('Confirm Transaction')
                        setIsFetching(false)
                    } else {
                        snackMessage(approvalResponse.message, 'error');
                    }
                    setIsFetching(false)
                    return;
                }
            } else {
                setIsFetching(false)
                snackMessage(allowanceResponse.message, 'error');
                return;
            }
            setIsFetching(false)

            const submissionResponse = await submitDumpster(selectedToken, tokenAmount);
            if (submissionResponse.success) {
                snackMessage(submissionResponse.message, "success");
                setIsFetching(true); 
                setTokenAmount(0)
                setSelectedToken(null)
                setSelectedTokenSymbol('Select Token')
                setIsFetching(false);
            } else {
                snackMessage(submissionResponse.message, "error")
            }
        } else if (!selectedToken) {
            setCustomTokenAddress('');
            setSearchResults([]);
            setOpenTokenDialog(true)
        }
    }

    function floorToDecimals(num, decimals) {
        const factor = 10 ** decimals;
        return (Math.floor(num * factor) / factor).toFixed(decimals);
    }

    const snackMessage = (message, variant) => {
        enqueueSnackbar(message, { variant });
        setTimeout(() => {
            closeSnackbar();
        }, 5000);
    };

 
    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 
        return regex.test(email);
    };
 
    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);

        setEmailError('')
    };

    const validateUserData = async () => {

        if (!validateEmail(email) && parseFloat(tokenAmount) > 0 && !!selectedToken) {
            setEmailError('Please enter a valid email address.');
            return;
        }

        if (!address) {
            setButtonName('Connect Wallet');
            return;
        }

        if (!selectedToken) {
            setButtonName('Get started');
            return;
        }

        if (chainId) {
            if (getChainId(selectedToken.network) != chainId.toString()) {
                setButtonName(`Switch to ${selectedToken.network == 'Binance Smart Chain' ? 'BSC' : selectedToken.network}`);
                return;
            }
        } else {
            setButtonName('Connect Wallet');
            return;
        }

        if (parseFloat(tokenAmount) == 0 || tokenAmount == '' || parseFloat(tokenAmount) < 0) {
            setButtonName('Enter an amount');
            return;
        }

        if (parseFloat(userTokenBalance) < parseFloat(tokenAmount)) {
            setButtonName('Insufficient Balance');
            return;
        }




        setButtonName('Confirm Transaction')
    }

    return (
        <>
            <div className="wallet-main" style={{ maxWidth: 1000, minHeight: 500 }}>
                {errorMessage.length > 0 && (
                    <Alert severity="error" style={{ marginBottom: 40 }}>
                        {errorMessage}
                    </Alert>
                )}
                <div className="wallet-body">
                    <div className="left" style={{ marginBottom: 10, marginRight: 20 }}>
                        {!hideBanner && (
                            <section className="crypto" data-aos="fade-up" data-aos-duration="1000" style={{ marginTop: 0 }}>
                                <div className="container" style={{ marginTop: 0 }}>
                                    <div className="row" style={{ marginTop: 0 }}>
                                        <div className="col-md-12" style={{ marginTop: 0 }}>
                                            <div className="crypto__main" style={{ marginTop: 0 }}>

                                                <h6 className="tab-subtitle" style={{ marginTop: 10 }}>OSCAR Giant Dumpster Airdrop: Turn Trash Into Treasure!</h6>
                                                <ul className="list" >
                                                    <li>
                                                        <h6 className="title" style={{ marginTop: 25 }}>
                                                            <span className="icon-check"></span>Deposit Failed Meme Coins
                                                        </h6>
                                                        <p className="text" style={{ marginTop: 18 }}>
                                                            Submit Any Failed Meme Coin from Ethereum, Base, Binance Smart Chain, Avalanche, or Solana.
                                                        </p>
                                                    </li>
                                                    <li style={{ marginTop: 15 }}>
                                                        <h6 className="title">
                                                            <span className="icon-check"></span>Earn Points & Multipliers
                                                        </h6>
                                                        <p className="text" style={{ marginTop: 18 }}>
                                                            Higher rank means more rewards.
                                                        </p>
                                                    </li>
                                                    <li style={{ marginTop: 15 }}>
                                                        <h6 className="title">
                                                            <span className="icon-check"></span>Claim Your OSCAR
                                                        </h6>
                                                        <p className="text" style={{ marginTop: 18 }}>
                                                            Your airdrop is calculated based on your total points.
                                                        </p>
                                                    </li>
                                                    <li style={{ marginTop: 15 }}>
                                                        <h6 className="title">
                                                            <span className="icon-check"></span>Vest & Earn More
                                                        </h6>
                                                        <p className="text" style={{ marginTop: 18 }}>
                                                            Unlock your airdrop rewards gradually over 24 months.
                                                        </p>
                                                    </li>
                                                </ul>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        )}
                    </div>
                    <div className="right">
                        <div
                            style={{
                                border: `2px solid ${isDark ? '#119f24' : '#119f24'}`,
                                borderRadius: '16px',
                                padding: '24px',
                                maxWidth: '400px',
                                marginTop: '22px',
                            }}
                        > 
                            <h4 style={{
                                color: isDark ? '#1c960e' : '#1c960e',  
                                marginBottom: '20px', 
                                fontSize: '18px',  
                                fontWeight: 'bold', 
                                textAlign: 'left',  
                            }}>
                                Submit for Airdrop
                            </h4>
 
                            <form
                                action="/wallet"
                                style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}  
                                onSubmit={(e) => e.preventDefault()}
                            > 
                                <TextField
                                    type="number"
                                    placeholder="Enter amount"
                                    variant="outlined"
                                    value={tokenAmount}
                                    onChange={e => setTokenAmount(e.target.value)}
                                    fullWidth
                                    sx={(theme) => ({
                                        marginBottom: 2,
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '16px',
                                            backgroundColor: isDark ? 'transparent' : '#fff',
                                            color: isDark ? '#fff' : '#000',
                                            '& fieldset': {
                                                borderColor: isDark ? '#119f24' : '#119f24'
                                            },
                                            '&:hover fieldset': {
                                                borderColor: isDark ? '#119f24' : '#119f24'
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: isDark ? '#119f24' : '#119f24'
                                            }
                                        },
                                        '& .MuiInputBase-input': {
                                            color: isDark ? '#fff' : '#000',
                                            '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                                display: 'none',
                                            },
                                            '&[type=number]': {
                                                MozAppearance: 'textfield',  
                                            }
                                        }
                                    })}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    onClick={() => {
                                                        setCustomTokenAddress('');
                                                        setSearchResults([]);
                                                        setOpenTokenDialog(true)
                                                    }
                                                    }
                                                    style={{
                                                        textTransform: "none",
                                                        borderRadius: "16px",
                                                        fontSize: "14px",
                                                        backgroundColor: "#119f24"
                                                    }}
                                                >
                                                    {!!selectedToken && (
                                                        <img
                                                            src={chainIcons[selectedToken.network]}
                                                            alt={selectedToken.network}
                                                            width="20"
                                                            height="20"
                                                            style={{ borderRadius: "50%", marginRight: 3 }}
                                                        />
                                                    )}
                                                    {` ${selectedTokenSymbol} ▼`}
                                                </Button>
                                            </InputAdornment>
                                        ),
                                    }}
                                    helperText={
                                        selectedToken ? (
                                            <span
                                                onClick={() => setTokenAmount(floorToDecimals(userTokenBalance, 2))}
                                                style={{ fontSize: "13px", fontWeight: "bold", cursor: "pointer", color: "#119f24" }}
                                            >
                                                Balance: {beautifyNumber(userTokenBalance, 2)}
                                            </span>
                                        ) : (
                                            ""
                                        )
                                    }
                                />


                                <TextField
                                    type="email"
                                    placeholder="Email address"
                                    variant="outlined"
                                    value={email}
                                    onChange={handleEmailChange}
                                    fullWidth
                                    error={emailError.length > 0 ? true : false}
                                    helperText={emailError.length > 0 ? emailError : ''}
                                    sx={(theme) => ({
                                        marginBottom: 2,
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '16px',
                                            backgroundColor: isDark ? 'transparent' : '#fff',
                                            color: isDark ? '#fff' : '#000',
                                            '& fieldset': {
                                                borderColor: isDark ? '#119f24' : '#119f24'
                                            },
                                            '&:hover fieldset': {
                                                borderColor: isDark ? '#119f24' : '#119f24'
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: isDark ? '#119f24' : '#119f24'
                                            }
                                        },
                                        '& .MuiInputBase-input': {
                                            color: isDark ? '#fff' : '#000',
                                        }
                                    })}
                                /> 
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="success"
                                    fullWidth
                                    style={{
                                        padding: "12px",
                                        fontSize: "16px",
                                        textTransform: "none",
                                        borderRadius: "16px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "10px",
                                        color: "white",
                                        backgroundColor: isFetching ? "#2e7d32" : '#119f24',
                                        opacity: isFetching ? 1 : undefined,
                                        marginBottom: 20
                                    }}
                                    onClick={handelProcess}
                                    disabled={isFetching}
                                >
                                    {isFetching && <CircularProgress size={20} sx={{ color: "white" }} />}
                                    {buttonName}
                                </Button>
                            </form>
                        </div>
                    </div>

                </div>
            </div >
            <Dialog
                open={openTokenDialog}
                onClose={() => setOpenTokenDialog(false)}
                PaperProps={{
                    sx: {
                        width: { xs: '95vw', sm: '70vw', md: '60vw' },
                        height: { xs: '95vh', sm: '80vh' },
                        borderRadius: '16px',
                        backgroundColor: isDark ? '#25292E' : 'background.paper',
                        padding: 2,
                        position: 'relative'
                    }
                }}
            >
                {loading && (
                    <Backdrop
                        open={loading}
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            zIndex: (theme) => theme.zIndex.drawer + 1,
                            color: isDark ? '#119f24' : '#fff'
                        }}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                )}
                <DialogTitle style={{ color: '#119f24' }}>Select Token</DialogTitle>
                <DialogContent dividers sx={{ position: 'relative' }}>
                    <TextField
                        autoFocus
                        placeholder="Search any token by address"
                        fullWidth
                        variant="outlined"
                        style={{ color: isDark ? "white" : "#25292E" }}
                        value={customTokenAddress}
                        onChange={handleTokenAddressChange}
                        error={Boolean(tokenAddressError)}
                        helperText={tokenAddressError}
                        sx={(theme) => ({
                            marginBottom: 2,
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '16px',
                                backgroundColor: isDark ? 'transparent' : '#fff',
                                color: isDark ? '#fff' : '#000',
                                '& fieldset': {
                                    borderColor: isDark ? '#119f24' : '#119f24'
                                },
                                '&:hover fieldset': {
                                    borderColor: isDark ? '#119f24' : '#119f24'
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: isDark ? '#119f24' : '#119f24'
                                }
                            },
                            '& .MuiInputBase-input': {
                                color: isDark ? '#fff' : '#000'
                            }
                        })}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon sx={{ color: '#119f24' }} />
                                </InputAdornment>
                            ),
                            endAdornment: customTokenAddress && (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={() => {
                                            setCustomTokenAddress('');
                                            setSearchResults([]);
                                        }}
                                        edge="end"
                                    >
                                        <CloseIcon sx={{ color: '#119f24' }} />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                        InputLabelProps={{
                            sx: {
                                color: '#119f24',
                                '&.Mui-focused': {
                                    color: '#119f24'
                                }
                            }
                        }}
                    />
                    <List>
                        {customTokenAddress && isAddress(customTokenAddress) ? (
                            searchResults.length > 0 ? (
                                searchResults.map((token) => {
                                    const networkInfo = {
                                        Ethereum: { icon: ethIcon, label: 'Ethereum' },
                                        'Binance Smart Chain': { icon: bnbIcon, label: 'BSC' },
                                        Avalanche: { icon: avaxIcon, label: 'Avalanche' },
                                        Solana: { icon: solIcon, label: 'Solana' },
                                        Base: { icon: baseIcon, label: 'Base' }
                                    };
                                    const net = networkInfo[token.network] || { icon: '', label: token.network };
                                    return (
                                        <ListItem
                                            button
                                            key={token.id}
                                            onClick={() => {
                                                setCustomTokenAddress(token.address);
                                                setSelectedTokenSymbol(token.symbol);
                                                setSelectedToken(token);
                                                setTokenAddressError('');
                                                setOpenTokenDialog(false);
                                            }}
                                        >
                                            <ListItemAvatar>
                                                <Avatar
                                                    src={token.icon ? token.icon : PriorityHighIcon}
                                                    alt={token.name}
                                                    sx={{ width: 30, height: 30 }}
                                                />
                                            </ListItemAvatar>
                                            <ListItemText
                                                style={{ color: isDark ? 'white' : 'grey' }}
                                                primary={<Typography variant="body2" noWrap>{token.name}</Typography>}
                                                secondary={
                                                    <Typography variant="caption" noWrap>
                                                        {token.symbol} - {token.address.substring(0, 6)}...
                                                        {token.address.substring(token.address.length - 4)}
                                                    </Typography>
                                                }
                                            />
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Avatar
                                                    src={net.icon}
                                                    alt={net.label}
                                                    sx={{ width: 24, height: 24, mr: 1 }}
                                                />
                                                <Typography variant="caption" noWrap sx={(theme) => ({ color: isDark ? '#fff' : '#000' })}>
                                                    {net.label}
                                                </Typography>
                                            </Box>
                                        </ListItem>
                                    );
                                })
                            ) : (
                                !loading && (
                                    <ListItem>
                                        <ListItemText primary="Token not found" />
                                    </ListItem>
                                )
                            )
                        ) : (
                            defaultTokens.map((token) => {
                                const networkInfo = {
                                    Ethereum: { icon: ethIcon, label: 'Ethereum' },
                                    'Binance Smart Chain': { icon: bnbIcon, label: 'BSC' },
                                    Avalanche: { icon: avaxIcon, label: 'Avalanche' },
                                    Solana: { icon: solIcon, label: 'Solana' },
                                    Base: { icon: baseIcon, label: 'Base' }
                                };
                                const net = networkInfo[token.network] || { icon: '', label: token.network };
                                return (
                                    <ListItem
                                        button
                                        key={token.id}
                                        onClick={() => {
                                            setCustomTokenAddress(token.address);
                                            setSelectedTokenSymbol(token.symbol);
                                            setSelectedToken(token);
                                            setTokenAddressError('');
                                            setOpenTokenDialog(false);
                                        }}
                                    >
                                        <ListItemAvatar>
                                            <Avatar
                                                src={token.icon}
                                                alt={token.name}
                                                sx={{ width: 30, height: 30 }}
                                            />
                                        </ListItemAvatar>
                                        <ListItemText
                                            style={{ color: isDark ? 'white' : 'grey' }}
                                            primary={<Typography variant="body2" noWrap>{token.name}</Typography>}
                                            secondary={
                                                <Typography variant="caption" noWrap>
                                                    {token.symbol} - {token.address.substring(0, 6)}...
                                                    {token.address.substring(token.address.length - 4)}
                                                </Typography>
                                            }
                                        />
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Avatar
                                                src={net.icon}
                                                alt={net.label}
                                                sx={{ width: 24, height: 24, mr: 1 }}
                                            />
                                            <Typography variant="caption" noWrap sx={(theme) => ({ color: isDark ? '#fff' : '#000' })}>
                                                {net.label}
                                            </Typography>
                                        </Box>
                                    </ListItem>
                                );
                            })
                        )}
                    </List>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default AirdropForm;
